<template>
  <div class="chat-summary-page col-block width-full">
    <div class="chat-summary-container col-block width-full">
      <div
        class="chat-summary-block col-block width-full"
        v-for="summaryData in summaryDatas"
        :key="summaryData.timestamp"
        :class="{ active: display[summaryData.timestamp] }"
      >
        <div class="chat-summary-data-container col-block width-full">
          <div class="chat-summary-data-title-container row-block" :class="display[summaryData.timestamp] ? ['flex-start'] : []">
            <div class="chat-summary-data-title" :class="display[summaryData.timestamp] ? ['break-line'] : ['ellipsis']" :style="{ flex: 1 }">{{ summaryData.title }}</div>
            <div class="chat-summary-data-display-icon icon-block" :style="{ '--size': '30px' }" @click="e => display[summaryData.timestamp] = !display[summaryData.timestamp]">
              <img :src="require('../../assets/images/case-edit-display-icon.svg')" alt="">
            </div>
          </div>
          <div v-if="display[summaryData.timestamp] && (summaryData.contents || []).length" class="chat-summary-data-block col-block width-full">
            <div class="chat-summary-data-content-container col-block width-full">
              <div
                class="chat-summary-data-content-block col-block flex-start"
                v-for="content in summaryData.contents"
                :key="content.timestamp"
              >
                <div class="chat-summary-data-content-title break-line">{{ [
                  { 'complete': '✓' }[content.status] || '•',
                  content.title
                ].join(' ') }}</div>
                <div :style="{ height: '5px' }"></div>
                <div class="chat-summary-data-content-summary break-line">{{ content.summary }}</div>
                <div v-if="content.source" class="chat-summary-data-content-source break-line">{{ $t('COMPONENT.chat.summary.___source') }}<span>{{ content.source }}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userPermission from '../../mixins/userPermission.vue'
import { sortData } from '../../constants/global/util'

export default {
  mixins: [
    userPermission
  ],
  props: {
    chats: {
      type: Array,
      default: () => []
    },
    botState: {
      type: String,
      default: () => ''
    },
    botChatData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      display: {}
    }
  },
  computed: {
    summaryDatas () {
      if (this.botChatData.summary.timestamp) {
        this.display = {
          ...this.display,
          [this.botChatData.summary.timestamp]: true
        }
      }
      return [
        ...this.chats.filter(chat => chat.msgType === 'answer').map(chat => chat.summary),
        this.botChatData.summary
      ].filter(summary => summary.contents).map(summary => ({
        ...summary,
        contents: sortData(Object.values(summary.contents), data => data.timestamp, 'asc')
      }))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chat/summary.vue